<nav class="navbar" [class.scrolled]="scrolled()">
  <div class="navbar__container container">
    <a class="navbar__logo" (click)="scrollTo('hero')">
      <img
        [ngSrc]="logoSrc()"
        [alt]="restaurantName() + ' logó – Pákozd, Velencei-tó'"
        class="logo-img"
        width="80"
        height="80"
        priority
      />
      <span class="logo-text brand-name">{{ restaurantName() }}</span>
    </a>

    <ul class="navbar__links" [class.open]="mobileMenuOpen()">
      @for (item of navItems(); track item.anchor) {
        <li>
          <a (click)="scrollTo(item.anchor)">{{ item.label }}</a>
        </li>
      }
      @if (themeToggleVisible) {
        <li class="navbar__theme-item">
          <button
            type="button"
            class="navbar__theme-toggle"
            [attr.aria-pressed]="theme() === 'light'"
            [attr.aria-label]="
              theme() === 'dark' ? 'Váltás világos megjelenésre' : 'Váltás sötét megjelenésre'
            "
            (click)="toggleTheme()"
          >
            @if (theme() === 'dark') {
              <svg class="navbar__theme-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path
                  fill="currentColor"
                  d="M12 2.25a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zM7.5 12a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm11.394-5.834a.75.75 0 00-1.06-1.06l-1.591 1.59a.75.75 0 101.06 1.061l1.591-1.59zM21.75 12a.75.75 0 01-.75.75h-2.25a.75.75 0 010-1.5H21a.75.75 0 01.75.75zm-3.105 7.834a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 10-1.061 1.06l1.59 1.591zM12 18a.75.75 0 01.75.75V21a.75.75 0 01-1.5 0v-2.25A.75.75 0 0112 18zm-4.242-2.697a.75.75 0 00-1.061-1.06l-1.591 1.59a.75.75 0 001.06 1.061l1.591-1.59zM6 12a.75.75 0 01-.75.75H3a.75.75 0 010-1.5h2.25A.75.75 0 016 12zm2.697-4.242a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 10-1.061 1.06l1.59 1.591z"
                />
              </svg>
            } @else {
              <svg class="navbar__theme-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path
                  fill="currentColor"
                  d="M9.528 1.718a.75.75 0 01.162.819A8.97 8.97 0 009 6a9 9 0 009 9 8.97 8.97 0 003.463-.69.75.75 0 01.981.98 10.503 10.503 0 01-9.694 6.46c-5.799 0-10.5-4.701-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 01.818.162z"
                />
              </svg>
            }
          </button>
        </li>
      }
      @if (showReservation()) {
        <li>
          <a class="navbar__cta" (click)="scrollTo('reservation')">Asztalfoglalás</a>
        </li>
      }
    </ul>

    <button
      class="navbar__hamburger"
      [class.active]="mobileMenuOpen()"
      (click)="toggleMobileMenu()"
      aria-label="Menü megnyitása"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>
</nav>
